import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=f36cf66a&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=f36cf66a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36cf66a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f36cf66a')) {
      api.createRecord('f36cf66a', component.options)
    } else {
      api.reload('f36cf66a', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=f36cf66a&scoped=true&", function () {
      api.rerender('f36cf66a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20E113LHZtKiR/JS/comp/Voucher.vue"
export default component.exports